const LOCAL_CERT_DOMAINS = [
  'local.pandalive.co.kr',
  'local.m.pandalive.co.kr',
  'local.bktv.kr',
  'local.m.bktv.kr',
  'local.masp.pandalive.co.kr',
  'local.wasp.pandalive.co.kr',
  'local.wasp.bktv.kr',
  'local.masp.bktv.kr',
  'local.livetv.ooh.co.kr',
  'local.mlivetv.ooh.co.kr',
  'local.sales.pandalive.co.kr',
  'local-dev.pandalive.co.jp',
  'local-dev-m.pandalive.co.jp',
  'dev.pandalive.co.jp',
  'dev-m.pandalive.co.jp',
  'pandalive.co.kr',
  '*.pandalive.co.kr',
  '*.m.pandalive.co.kr',
  'pandalive.co.jp',
  '*.pandalive.co.jp',
  '*.m.pandalive.co.jp',
  '*.dev.pandalive.co.jp',
  '*.bktv.kr',
  '*.m.bktv.kr',
  'bktv.kr',
  '*.yesfile.com',
  'yesfile.com',
  '*.filekuki.com',
  'filekuki.com',
  '*.kdisk.co.kr',
  '*.plive.kr',
  '*.filejo.com',
  '*.m.bktv.dmm.co.jp',
  'mlivetv.ondisk.co.kr',
  '*.ondisk.co.kr',
  'smartfile.co.kr',
  '*.smartfile.co.kr',
  '*.fileis.com',
  'm.wedisk.co.kr',
  'mlivetv.tple.co.kr',
];

export { LOCAL_CERT_DOMAINS };
